import React, { createContext, useContext, useState, ReactNode } from 'react';

interface FormHeaderData {
  formTitle: string;
  formType?: string;
  formCode?: string;
  formVersion?: string;
  schemaVersion?: string;
  viewType?: string; // View type from JSON (e.g., "Form View", "Clinical View")
}

interface FormHeaderContextType {
  headerData: FormHeaderData | null;
  setHeaderData: (data: FormHeaderData | null) => void;
}

const FormHeaderContext = createContext<FormHeaderContextType | undefined>(undefined);

export const FormHeaderProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [headerData, setHeaderData] = useState<FormHeaderData | null>(null);

  return (
    <FormHeaderContext.Provider value={{ headerData, setHeaderData }}>
      {children}
    </FormHeaderContext.Provider>
  );
};

export const useFormHeader = () => {
  const context = useContext(FormHeaderContext);
  // Return default values if context is not available (for non-form pages)
  if (context === undefined) {
    return { headerData: null, setHeaderData: () => {} };
  }
  return context;
};

